/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import i18n from "@/i18n";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: i18n.t('menu.dashboad.url'),
          name:i18n.t('menu.dashboad.name'),
          component: () => import('./views/Home.vue'),
          meta: {
            breadcrumb: i18n.t('menu.dashboad.meta.breadcrumb'),
            pageTitle: i18n.t('menu.dashboad.meta.pageTitle'),
            rule: i18n.t('menu.dashboad.meta.rule'),
          }

        },
        {
          path: '/studentssimple',
          name: 'studentssimple',
          component: () => import('./views/Student.vue')
        },
        {
          path: i18n.t('menu.students.url'),
          name: i18n.t('menu.students.name'),
          component: () => import('@/views/students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students.meta.pageTitle'),
            rule: i18n.t('menu.students.meta.rule'),
          }
        },
        {
          path: i18n.t('menu.students_user.url'),
          name: i18n.t('menu.students_user.name'),
          component: () => import('@/views/user-students/DataListView.vue'),
          meta: {
            breadcrumb: i18n.t('menu.students_user.meta.breadcrumb'),
            pageTitle: i18n.t('menu.students_user.meta.pageTitle'),
            rule: i18n.t('menu.students_user.meta.rule')
          }
        },
        {
          path:  i18n.t('menu.users.url'),
          name:  i18n.t('menu.users.name'),
          component: () => import('@/views/cam-users/DataListView.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.users.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.users.meta.pageTitle'),
            rule:  i18n.t('menu.users.meta.rule'),
          }
        },
        {
          path:  i18n.t('menu.incidents.url'),
          name:  i18n.t('menu.incidents.name'),
          component: () => import('@/views/incidents/Incidents.vue'),
          meta: {
            breadcrumb:  i18n.t('menu.incidents.meta.breadcrumb'),
            pageTitle:  i18n.t('menu.incidents.meta.pageTitle'),
            rule:  i18n.t('menu.incidents.meta.rule'),
          }
        },
        {
          path: '/tickets',
          name: 'Tickets',
          component: () => import('./views/tickets/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tickets', active: true }
            ],
            pageTitle: 'Tickets',
            rule: 'manager'
          }
        },
        {
          path: "/ticket/:ticketId",
          name:"Ticket Profile",
          component: () => import('@/views/tickets/Profile.vue'),
          meta: {
            breadcrumb:[
              {
                "title": "Home",
                "url": "/"
              },
              {
                "title": "Tickets",
                "url": "/tickets"
              },
              {
                "title": "View",
                "active": true
              }
            ],
            pageTitle:"Ticket View",
            rule: "manager"
          }
        },
        {
          path: '/locations',
          name: 'Locations',
          component: () => import('./views/locations/ListView.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Locations', active: true }
            ],
            pageTitle: 'Locations',
            rule: 'manager'
          }
        },
        {
          path: "/locations/:locationId",
          name:"Location Profile",
          component: () => import('@/views/locations/profile.vue'),
          meta: {
            breadcrumb:[
              {
                "title": "Home",
                "url": "/"
              },
              {
                "title": "Locations",
                "url": "/locations"
              },
              {
                "title": "View",
                "active": true
              }
            ],
            pageTitle:"Location View",
            rule: "manager"
          }
        },
              {
                path: '/programs',
                name: 'Programs',
                component: () => import('./views/programs/programsListView'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Programs', active: true }
                  ],
                  pageTitle: 'Programs',
                  rule: 'manager'
                }
              },
              {
                path: '/cameras',
                name: 'Cameras',
                component: () => import('./views/cameras/ListView.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Cameras', active: true }
                  ],
                  pageTitle: 'Cameras',
                  rule: 'manager'
                }

              },
              {
                path: '/schedules',
                name: 'Schedules',
                component: () => import('./views/schedules/ListView.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Schedules', active: true }
                  ],
                  pageTitle: 'Schedules',
                  rule: 'manager'
                }
              },{
                path: '/theme-customizer',
                name: 'Theme Customizer',
                component: () => import('./views/Settings/ThemeCustomizer'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Theme Customizer', active: true }
                  ],
                  pageTitle: 'Theme Customizer',
                  rule: 'admin'
                }
              },
              {
                path: '/managers',
                name: 'managers',
                component: () => import('@/views/managers/DataListView.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Managers', active: true }
                  ],
                  pageTitle: 'Managers',
                  rule: 'manager'
                }
              },
              {
                path: i18n.t('route.student_profile.url'),
                name:i18n.t('route.student_profile.name'),
                component: () => import('@/views/students/profile.vue'),
                meta: {
                  breadcrumb:i18n.t('route.student_profile.meta.breadcrumb'),
                  pageTitle:i18n.t('route.student_profile.meta.pageTitle'),
                  rule: i18n.t('route.student_profile.meta.rule'),
                }
              },
              {
                path: i18n.t('route.user_profile.url'),
                name: i18n.t('route.user_profile.name'),
                component: () => import('@/views/cam-users/profile.vue'),
                meta: {
                  breadcrumb:i18n.t('route.user_profile.meta.breadcrumb'),
                  pageTitle: i18n.t('route.user_profile.meta.pageTitle'),
                  rule: i18n.t('route.user_profile.meta.rule'),
                }
              },
              {
                path: '/student/cameras/:camId',
                name: 'app-camera-view',
                component: () => import('@/views/students/camprofile.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Students', url:'/students' },
                    { title: 'View', active: true }
                  ],
                  pageTitle: 'Camera View',
                  rule: 'user'
                }
              },
              {
                path: '/incident/:id',
                name: 'view-incident',
                component: () => import('@/views/incidents/ViewIncident.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Incidents', url:'/incidents' },
                    { title: 'View', active: true }
                  ],
                  pageTitle: 'Incident View',
                  rule: 'manager'
                }
              },
              {
                path: '/students/cameras/:camId',
                name: 'camera-view',
                component: () => import('@/views/user-students/camprofile.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Students', url:'/students' },
                    { title: 'View', active: true }
                  ],
                  pageTitle: 'Camera View',
                  rule: 'user'
                }
              },
              {
                path: i18n.t('menu.admins.url'),
                name: i18n.t('menu.admins.name'),
                component: () => import('@/views/admins/DataListView.vue'),
                meta: {
                  breadcrumb: i18n.t('menu.admins.meta.breadcrumb'),
                  pageTitle: i18n.t('menu.admins.meta.pageTitle'),
                  rule: i18n.t('menu.admins.meta.rule'),
                }
              },
              {
                path: i18n.t('menu.users_profile.url'),
                name: i18n.t('menu.users_profile.name'),
                component: () => import('@/views/cam-users/ViewUserProfile.vue'),
                meta: {
                  breadcrumb:i18n.t('menu.users_profile.meta.breadcrumb'),
                  pageTitle: i18n.t('menu.users_profile.meta.pageTitle'),
                  rule: i18n.t('menu.users_profile.meta.rule'),
                }
              },
              {
                path: '/dailylogins',
                name: 'Daily Login',
                component: () => import('./views/reports/DailyLogin.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Daily Logins', active: true }
                  ],
                  pageTitle: 'Daily Logins',
                  rule: 'manager'
                }
              },
              {
                path: '/dailywatchtime',
                name: 'Daily Watch Time',
                component: () => import('./views/reports/DailyWatch.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Daily Watch Time', active: true }
                  ],
                  pageTitle: 'Daily Watch Time',
                  rule: 'manager'
                }
              },
              {
                path: '/log-report',
                name: 'Log Report',
                component: () => import('./views/reports/LogReportView.vue'),
                meta: {
                  breadcrumb: [
                    { title: 'Home', url: '/' },
                    { title: 'Log Report', active: true }
                  ],
                  pageTitle: 'Log Report',
                  rule: 'manager'
                }
              },

            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: 'login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: 'register/:code?',
                name: 'page-register',
                component: () => import('@/views/pages/Register'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: 'email-confirmation',
                name: 'email-confirmation',
                component: () => import('@/views/pages/EmailConfirmationPage'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: 'verify-email/:pin_time?',
                name: 'verify-email',
                component: () => import('@/views/pages/VerifyEmailPage'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: 'verify-invited-user-email/:pin_time',
                name: 'verify-invited-user-email',
                component: () => import('@/views/pages/VerifyInvitedUserEmail'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: 'password/reset/:token?',
                name: 'reset-password',
                component: () => import('@/views/pages/ResetPassword'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: 'forgot-password',
                name: 'forgot-password',
                component: () => import('@/views/pages/ForgotPassword'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: 'resend-confirmation-email',
                name: 'resend-confirmation-email',
                component: () => import('@/views/pages/ResendTokenEmail'),
                meta: {
                  rule: 'guest'
                }
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
